import React from 'react';
import FormComponent from './components/Form';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';

function App() {
    return (
        <div className='App'>
            <FormComponent />
        </div>
    );
}

export default App;
